import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { of } from 'rxjs/observable/of';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  constructor() {
  }


  /**
   * Get access token
   * @returns {Observable<string>}
   */
  public getAccessToken(): Observable<string> {
    const token: string = <string>localStorage.getItem('accessToken');
    return of(token);
  }

  /**
   * Set access token
   * @returns {LocalStorageService}
   */
  public setAccessToken(token: string): LocalStorageService {
    localStorage.setItem('accessToken', token);

    return this;
  }

  /**
   * Get refresh token
   * @returns {Observable<string>}
   */
  public getRefreshToken(): Observable<string> {
    const token: string = <string>localStorage.getItem('refreshToken');
    return of(token);
  }

   /**
   * Set refresh token
   * @returns {LocalStorageService}
   */
  public setRefreshToken(token: string): LocalStorageService {
    localStorage.setItem('refreshToken', token);

    return this;
  }

  /**
   * Get side.
   * VA students could be on dark side - room 3300
   * or light side - room 3200.
   * IL students doesn`t have side.
   * @returns {Observable<string>}
   */
  public getClusterName(): Observable<string> {
    let name: string = <string>localStorage.getItem('cluster');
    return of(name);
  }

  /**
   * Set side
   * @returns {LocalStorageService}
   */
  public setClusterName(name: string): LocalStorageService {
    localStorage.setItem('cluster', name);
    
    return this;
  }

   /**
   * Remove storage
   */
  public clear() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('cluster');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/local-storage.service.ts